<app-menu></app-menu>

<div class="main-admin-menu" *ngIf="GetActiveUser()">
    <div class="admin-menu">
        <h5>Witaj!&nbsp;<strong>{{displayName()}}</strong></h5>
        <button type="button" class="btn btn-success" (click)="openModal()">Dodaj wiadomość!</button>
        <button type="button" class="btn btn-info" (click)="navigateToLogout()">Wyloguj</button>
    </div>
</div>

<div class="main">
    <div class="card main-card" *ngFor="let parent of parents">
        <div class="card-body">
            <div id="content" [innerHTML]="parent.text | safeHtml" class="card-text"></div>
            <h2>Zamieszczono: {{parent.date | date: 'dd/MM/yyyy'}}</h2>
            <button *ngIf="parent.fileName" (click)="downloadFile(parent)" class="btn btn-primary mb-2">Pobierz załącznik: {{parent.fileName}}</button>
            <button type="button" class="btn btn-success" (click)="deleteParent(parent)" *ngIf="GetActiveUser()">Usuń</button>
            <button type="button" class="btn btn-warning" (click)="openModalEdit(parent)" *ngIf="GetActiveUser()">Edytuj</button>
        </div>
    </div>
</div>